import request from '@/router/axios'

const base = '/api/produce/stock-take'

// 盘点单分页列表
export const getSheetPage = (params) =>
  request({
    url: `${base}/sheet/page`,
    method: 'get',
    params
  })

// 盘点单详情
export const getSheetDetail = (sheetId) =>
  request({
    url: `${base}/detail/${sheetId}`,
    method: 'get'
  })

// 生成盘点单编号
export const getNextSheetNo = () =>
  request({
    url: `${base}/next-sheet-no`,
    method: 'get'
  })

// 煤棚/库区（库位主数据，与 location pycode 一致）
export const getLocationDistinct = (data = {}) =>
  request({
    url: `${base}/location/distinct`,
    method: 'post',
    data
  })

// 盘点煤棚：base_store 料场(煤棚)
export const getStoreSheds = () =>
  request({
    url: `${base}/store/sheds`,
    method: 'get'
  })

// 某煤棚下已签约堆位 base_store_sub
export const getContractedStacks = (mainId) =>
  request({
    url: `${base}/store/contracted-stacks`,
    method: 'get',
    params: { mainId }
  })

// 盘点账面行（从 stock_management 拉取）；params 可含 stockCode、locationCode、dt(yyyy-MM-dd)
// 空字符串 dt 会导致 Spring @DateTimeFormat(yyyy-MM-dd) 绑定失败，故不传
export const getInventoryLines = (params = {}) => {
  const p = { ...params }
  if (p.dt === '' || p.dt === null || p.dt === undefined) {
    delete p.dt
  } else if (typeof p.dt === 'string' && p.dt.length > 10) {
    p.dt = p.dt.substring(0, 10)
  }
  return request({
    url: `${base}/inventory-lines`,
    method: 'get',
    params: p
  })
}

// 提交盘点单
export const submitSheet = (data) =>
  request({
    url: `${base}/submit`,
    method: 'post',
    data
  })

